import { Licenses } from "../Data/Licenses.ts"
export const phoneNoRegex = '^(\+)?\d*$/'
export const phoneNoRegexWith48 = /^\+48\s\d{3}\s\d{3}\s\d{3}$/
export const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
export const zipCodeRegex = /^[0-9]{2}-[0-9]{3}$/

export const validateEmail = (email) => {
    return emailRegex.test(email);
};

export const validatePhoneNo = (phone) => {
    return phoneNoRegex.test(phone);
};

export const validatePhoneNoWith48 = (phone) => {
    return phoneNoRegexWith48.test(phone);
};

export const validateZipCode = (zipCode) => {
    return zipCodeRegex.test(zipCode);
};

export const getIndeksHeader = (license) => {
    switch (license) {
        case Licenses.TgInstalacje:
            return 'INDEKS TG'
        default:
            return 'INDEKS'
    }
}